import { EventType } from '@/shared/enums';

export default {
  mounted() {
    this.$EventBus.on(EventType.RESIZE, this.scrollOnResize);
  },
  beforeDestroy() {
    this.$EventBus.off(EventType.RESIZE, this.scrollOnResize);
  },
  methods: {
    scrollOnResize() {
      this.$refs.scroll?.perfectScroll?.update();
    },
  },
};
